module.exports = __webpack_public_path__ + "static/hackathon-response-min-225ed62f6b3d3432a55c21a5fce2b2b4.jpg";